module.exports = __webpack_public_path__ + "img/poi.e48a5a07.png";